export default __webpack_public_path__ + "76ec2aa971e94b69221f402099b1156c.png";